import React from 'react'
import { useArq } from '../use-arq/use-arq'

export type iIsAuthenticated = (params: {
  children: React.ReactNode
}) => JSX.Element | null
const IsAuthenticated: iIsAuthenticated = ({ children }) => {
  const { auth } = useArq()

  if (auth.isAuthenticated) return <>{children}</>

  return null
}

export { IsAuthenticated }
